export default __webpack_public_path__ + "static/lg-fd62dfdcc030fd63c90e45cacd48b565.png";